/* eslint-disable */
// Voting marketing optedIn
export default {
    inserted: function (el, binding, vnode) {
        // const url = binding.value;
        // const url = 'https://run.mocky.io/v3/a4720da8-ae94-470e-bfb5-0aeb5c970f6d?mocky-delay=500ms';
        const url = `${window.location.origin}/aha-service/social/submitoptinform`;

        const inputEmail = document.querySelector('#email');

        const marketingSignUp = document.querySelector('#marketing-sign-up');

        marketingSignUp.disabled = true;

        const firstName = document.querySelector('#first-name');
        const lastName = document.querySelector('#last-name');
        const zipcode = document.querySelector('#zipcode');
        const optedIn = document.querySelector('#opt-in-checkbox');

        const thankYouDiv = document.querySelector('#divThankYou');
        const thankyouMessage = document.querySelector('.thankyouMessage');
        const signupform = document.querySelector('.signupform');
        const newsLetterComponent = document.querySelector('.c-listing-header');

        thankYouDiv.classList.add('d-none');

        // Error messages
        const zipcodeError = document.querySelector('#zipcode-error');

        zipcode.setAttribute('aria-describedby', '');

        const checkRemainingFiledValidity = (keyvalue, remainingFiledValidity) => {
            if (keyvalue && remainingFiledValidity) {
                marketingSignUp.disabled = false;
            } else {
                marketingSignUp.disabled = true;
            }
        };

        // Doing zipcode validation and showing an error message and disabled and enabled the sign up button.
        zipcode.addEventListener('keyup', function (e) {
            const zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            const remainingFiledValidity = firstName.value && lastName.value && optedIn.checked;
            if (zipcodeRegex.test(this.value)) {
                zipcodeError.classList.add('d-none');
                zipcode.setAttribute('aria-describedby', '');
                if (remainingFiledValidity) {
                    marketingSignUp.disabled = false;
                }
            }
        })

        // Doing zipcode validation and showing an error message and disabled and enabled the sign up button.
        zipcode.addEventListener('focusout', function (e) {
            const zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            const remainingFiledValidity = firstName.value && lastName.value && optedIn.checked;
            if (!zipcodeRegex.test(this.value)) {
                zipcodeError.classList.remove('d-none');
                zipcode.setAttribute('aria-describedby', 'zipcode-error');
                marketingSignUp.disabled = true;
            } else {
                zipcodeError.classList.add('d-none');
                zipcode.setAttribute('aria-describedby', '');
                if (remainingFiledValidity) {
                    marketingSignUp.disabled = false;
                }
            }
        })

        firstName.addEventListener('keyup', function (e) {
            const zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            const remainingFiledValidity = lastName.value && zipcodeRegex.test(zipcode.value) && optedIn.checked;
            checkRemainingFiledValidity(this.value, remainingFiledValidity);
        });

        lastName.addEventListener('keyup', function (e) {
            const zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            const remainingFiledValidity = firstName.value && zipcodeRegex.test(zipcode.value) && optedIn.checked;
            checkRemainingFiledValidity(this.value, remainingFiledValidity);
        });

        optedIn.addEventListener('change', function (e) {
            const zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            const remainingFiledValidity = firstName.value && lastName.value && zipcodeRegex.test(zipcode.value);
            checkRemainingFiledValidity(this.checked, remainingFiledValidity);
        });


        const signUp = async () => {
            let payLoad = {
                FirstName: firstName.value,
                LastName: lastName.value,
                Email: inputEmail.value,
                Zipcode: zipcode.value,
                OptedIn: optedIn.checked,
                ContactId: document.querySelector('#hidContactId').value,
                ContextItemId: document.querySelector('#hidContextPageId').value,
                GoogleCaptchaToken: document.querySelector('#googleCaptchaToken').value
            };

            try {
                const res = await fetch(url, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': 'token-value'
                    },
                    body: JSON.stringify(payLoad, null, 2)
                });

                if(!res.ok) {
                    const message = `An error has occurred: ${res.status} - ${res.statusText}`;
                    throw new Error(message);
                }

                const data = await res.json();
                if (data.Success) {
                    signupform.classList.add('d-none');
                    newsLetterComponent.classList.add('d-none');
                    thankYouDiv.classList.add('d-block');
                    setTimeout(() => {
                        thankyouMessage.innerHTML = data.SuccessMessage;
                    }, 50);
                }
            } catch (err) {
                console.log(err);
            }
        };

        // signup button
        marketingSignUp.addEventListener('click', function (e) {
            e.preventDefault();
            signUp();
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/voting-marketing-optedIn.js